import Axios from "../../src/helpers/axios";

export const getAllPaymentChannel = () => {
  return Axios.get("/api/ecommerce/v1/mpaymentchannels/all");
};